module.exports = __webpack_public_path__ + "../resources/img/success_icon.ddbe9613.svg";